module.exports = __webpack_public_path__ + "static/img/fossil_fuel.1777b350.png";